export default "__VITE_ASSET__CfuPmj7d__"